import { StepBase } from './StepBase'
import { StepButton } from './StepButton'
import { PageStepType } from './PageTypes';

export class StepDashButton extends StepButton
{
    /** Holds the icon if found */
    icon : string = "";

    constructor(rawData :PageStepType)
    {
        super(rawData);

        let reIcon = /(<[^>]+>)/;
        let matches = this.text.match(reIcon);
        if (matches && matches[0])
        {
            this.icon = matches[1].replace("<", "").replace(">", "");
            this.text = this.text.replace(reIcon, "");
        }

    }
}